module.exports = __webpack_public_path__ + "static/media/planilha-minhas-empresa.7b44bbd2.xlsx";